var map = {
	"./apa-5th-edition.csl": 7240,
	"./bibtex.csl": 8211,
	"./chicago-note-bibliography-16th-edition.csl": 4622,
	"./ieee.csl": 8553,
	"./modern-language-association.csl": 733,
	"./national-library-of-medicine-grant-proposals.csl": 4921
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5331;